import CreateTemplateDialog from './CreateTemplateDialog';

export default CreateTemplateDialog;
